import { MuiTable, Typography } from 'fmc-digital-common';
import { Hidden, Box, HStack } from 'native-base';
import React, { memo } from 'react';
import { TableData } from '../../../utils/Data/TableData';
import TableTitle from '../TableTitle';
import TaskCardSkeleton from '../TaskCardSkeleton';
import TaskRowSkeleton from '../TaskRowSkeleton';
const TaskLoader = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hidden, {
    till: "lg"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableTitle, {
    title: "Tasks",
    filterText: ""
  }), /*#__PURE__*/React.createElement(MuiTable, {
    tableHeadList: TableData.tableHeadList
  }, [0, 1, 2, 3, 4, 5, 6, 7].map(each => /*#__PURE__*/React.createElement(TaskRowSkeleton, {
    key: each,
    bgColor: `${each % 2 === 0 ? 'white.500' : 'white.800'}`
  }))))), /*#__PURE__*/React.createElement(Hidden, {
    from: "lg"
  }, /*#__PURE__*/React.createElement(Box, {
    borderColor: 'lightBlue.400',
    borderRadius: '4',
    borderWidth: 1,
    p: 2,
    backgroundColor: 'white.500'
  }, /*#__PURE__*/React.createElement(HStack, {
    mb: 2,
    alignItems: 'baseline',
    space: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "title2",
    color: "darkGray.900"
  }, "Tasks")), [0, 1, 2, 3].map(each => /*#__PURE__*/React.createElement(TaskCardSkeleton, {
    key: each,
    bgColor: `${each % 2 === 0 ? 'white.500' : 'white.800'}`
  })))));
};
export default /*#__PURE__*/memo(TaskLoader);
//# sourceMappingURL=index.js.map